
/** Create queue. Actions may be added to queue as regular objects such as { duration, callback }, where:
    duration : seconds action takes to complete
    callback : to call on every update with current being passed in range from 0 to duration
    condition : if specified, function which will be used to determine if action completes
*/
export function action()
{
    const a = []
    a.karet = 0
    return a
}

export function clear_action( a )
{
    a.karet = 0
    a.length = 0
}

function complete( action )
{
    action.shift()
    action.karet = 0
}

/** Update specified queue. */
export function live( action, seconds )
{
    while ( action.length > 0 )
    {
        let next = action[ 0 ]
        if ( next.condition )
        {
            if ( next.condition( seconds ) ) complete( action )
            else break
        }
        else
        {
            if ( next.duration )
            {
                if ( next.callback ) next.callback( action.karet )
                if ( action.karet >= next.duration ) complete( action )
                else break
            }
            else
            {
                if ( next.callback ) next.callback()
                complete( action )
            }
        }
    }

    action.karet += seconds
}



// WEBPACK FOOTER //
// ./src/library/actions.es6